import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { fullName } from '../../../common/helpers/users';

const renderOption = barber => (
  <option key={barber.id} value={barber.id}>{fullName(barber)}</option>
);

const BarberPicker = props => (
  <Field
    component="select"
    name="barberId"
    className="c-select"
    disabled={props.disabled}
  >
    <option value="" selected disabled>Select a barber</option>
    {props.barbers.map(renderOption)}
  </Field>
);

BarberPicker.propTypes = {
  disabled: PropTypes.bool.isRequired,
  barbers: PropTypes.array,
};

export default BarberPicker;
